import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("empro_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const v = localStorage.getItem("empro_view");
  if (v) cfg.headers["X-View"] = v;
  try { cfg.headers["X-App-Origin"] = window.location.origin; } catch (e) { /* noop */ }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("empro_token");
      window.dispatchEvent(new Event("empro-logout"));
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Wystąpił błąd";
};

export const pln = (v) =>
  new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(v || 0);

export const fmtNip = (v) => {
  const d = String(v || "").replace(/\D/g, "");
  if (d.length === 10) return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8, 10)}`;
  return String(v || "");
};

export const downloadBlob = async (path, filename, label = "pliku") => {
  const tid = toast.loading(`Przygotowywanie ${label}…`);
  try {
    const res = await api.get(path, {
      responseType: "blob",
      onDownloadProgress: (e) => {
        const pct = e.total ? Math.round((e.loaded / e.total) * 100) : null;
        toast.loading(pct !== null ? `Pobieranie ${label}… ${pct}%` : `Pobieranie ${label}…`, { id: tid });
      },
    });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Pobrano ✓", { id: tid });
  } catch (e) {
    toast.error("Nie udało się pobrać pliku", { id: tid });
    throw e;
  }
};
